import React, { useEffect } from 'react'
import styled from 'styled-components/macro'

import { Error, P, H5 } from '../text'

const FormField = styled.fieldset`
    border: none;
    padding: 0;
	position: relative;
    ${props => props.width && `width: ${props.width};`}
`

const VisuallyHiddenLegend = styled.legend`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const FormInput = styled.input`
    background: ${props =>
        props.background ? props.background : 'white'};
    border: 2px solid lightgray;
    border-radius: 5px;
    display: block;
    padding: 10px 15px;
    font-size: 15px;
    color: ${props => (props.color ? props.color : 'black')};
    margin: 0;
    width: calc(100% - 30px);
    &[type='checkbox'] {
        padding: 0;
        width: 18px;
    }
    &:focus {
        box-shadow: inset 0 0 0 2px #D8E8FD;
    }
`

const FormArea = styled.textarea`
    background: ${props =>
        props.background ? props.background : 'white'};
	height: ${props => props.height ? props.height : '100px'};
    border: none;
    border-radius: 5px;
    display: block;
    padding: 10px 15px;
    font-size: 15px;
    color: ${props => (props.color ? props.color : 'black')};
    margin: 0;
    width: calc(100% - 30px);
    &[type='checkbox'] {
        padding: 0;
        width: auto;
    }
`

const FormSelect = styled.select`
    background: ${props =>
        props.background ? props.background : 'white'};
	height: ${props => props.height ? props.height : 'auto'};
    border: 2px solid lightgray;
    border-radius: 5px;
    display: block;
    padding: 10px 15px;
    font-size: 15px;
    color: ${props => (props.color ? props.color : 'black')};
    margin: 0;
    width: 100%;
    &[type='checkbox'] {
        padding: 0;
        width: auto;
    }
    &:focus {
        box-shadow: inset 0 0 0 2px #D8E8FD;
    }
`

const FormOption = styled.option`
    border: none;
    border-radius: 5px;
    display: block;
    padding: 10px 15px;
    font-size: 15px;
    color: ${props => (props.color ? props.color : 'black')};
    margin: 0;
    width: 100%;
    &[type='checkbox'] {
        padding: 0;
        width: auto;
    }
`

export const AdjustmentPrice = styled.span`
    font-size: 0.85em;
    font-weight: normal;
`

export const Input = props => {
    return (
        <FormField width={props.width}>
            {props.title && 
                <H5 margin="0 0 15px 0" weight="bold">
                    {props.required && "* "}{props.title}
                    {props.formatedAdjastmentPrice && <AdjustmentPrice>{props.formatedAdjastmentPrice}</AdjustmentPrice>}
                </H5>
            }
            {props.children && <P hover="white" color="white">{props.children}</P>}
            {props.legend && <VisuallyHiddenLegend>{props.legend}</VisuallyHiddenLegend>}
            <FormInput
                id={props.id}
                value={props.value}
                onChange={props.onChange}
                type={props.type}
                maxLength={props.maxLength}
                disabled={props.disabled}
                checked={props.checked}
                defaultChecked={props.defaultChecked}
                placeholder={props.placeholder}
                background={props.background}
                color={props.color} />
            {
                props.maxLength > 0 && <P margin="10px 0 0 0">
                    {`(${props.maxLength} characters max.`}
                    {props?.displayEmborideryText === "LC1" || props?.displayEmborideryText === "RC1" || props?.displayEmborideryText === "RP2" || props?.displayEmborideryText === "LP2" ?
                        " Name will be embroidered exactly how entered." : ""}
                    )
                </P>
            }
            {props.error
                && (props.error.length > 0) && <Error>
                    {props.error}
                </Error>
            }
        </FormField>

    )
}

export const TextArea = props => {
    return (
        <FormField width={props.width}>
            {props.children && <P hover="white" color="white">{props.children}</P>}
            {props.legend && <VisuallyHiddenLegend>{props.legend}</VisuallyHiddenLegend>}
            <FormArea
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                placeholder={props.placeholder}
                background={props.background}
                color={props.color}
                height={props.height} />
            {props.error
                && <Error>
                    {props.error}
                </Error>
            }
        </FormField>
    )
}

export const Select = props => {

    useEffect(() => {
        if(props.mode === "new" && (props.title === 'Alter Body Length' || props.title === 'Alter Sleeve Length') && props.value === ""){
            props.chooseSelect();
        }
    },[])

    return (
        <FormField width={props.width}>
            {(props.title === 'Alter Body Length' || props.title === 'Alter Sleeve Length') && !props.displayFlag ?
                "" :
                <>
                    {props.title && <H5 margin="0 0 15px 0" weight="bold">{props.required && "* "}{props.title}</H5>}
                    {props.legend && <VisuallyHiddenLegend>{props.legend}</VisuallyHiddenLegend>}
                    <FormSelect
                        onChange={props.onChange}
                        disabled={props.disabled}
                        placeholder={props.placeholder}
                        background={props.background}
                        color={props.color}
                        height={props.height}
                        value={props.value}
                        aria-label={props.ariaLabel}
                        style={{ width: props.title === 'Alter Body Length' || props.title === 'Alter Sleeve Length' ? "90%" : "100%" }}
                    >
                        <FormOption value="">
                            Please Select {props.title}
                        </FormOption>
                        {props.options && props.options.map((option, key) =>
                            <FormOption key={`FormOption-${option.value}-${option.displayName}-${key}`} value={option.optionOsr}>
                                {option.displayName}{(option.adjustmentPrice && (option.adjustmentPrice > 0)) ? ` [+ $${option.adjustmentPrice.toFixed(2)}]` : ``}
                            </FormOption>
                        )}
                    </FormSelect>
                </>
            }
            {props.error
                && <Error>
                    {props.error}
                </Error>
            }
        </FormField>
    )
}

export const SelectImg = props => {
    return (
        <FormField width={props.width}>
            {props.title && <H5 margin="0 0 15px 0" weight="bold">{props.required && "* "}{props.title}</H5>}
            {props.legend && <VisuallyHiddenLegend>{props.legend}</VisuallyHiddenLegend>}
            <FormSelect
                onChange={props.onChange}
                disabled={props.disabled}
                placeholder={props.placeholder}
                background={props.background}
                color={props.color}
                height={props.height}
                value={props.value}>
                {/* <FormOption value="">
                    Please select {props.title}
                </FormOption> */}
                {props.options && props.options.map((option, key) =>
                    <FormOption key={option} value={option}>
                        {option}
                    </FormOption>
                )}
            </FormSelect>
            {props.error
                && <Error>
                    {props.error}
                </Error>
            }
        </FormField>
    )
}
